<template>
    <modal @close="closeFromModal">
        <h5 slot="header">
            {{ closure_id ? $tl("labels.form.actions.edit") : $tl("labels.form.actions.add") }}
            {{ $tl("labels.clickAndCollect.modals.titles.closure") }}
        </h5>
        <div slot="body">
            <add-click-and-collect-closure :closure_id="closure_id" ref="addClickAndCollectClosure" @saved="$emit('saved', $event)" />
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="close">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button type="button" class="btn btn-sm btn-success btn-circle ms-2" @click="$refs.addClickAndCollectClosure.save()">
                {{ $tl("labels.form.actions.save") }}
            </button>
        </div>
    </modal>
</template>

<script>
import addClickAndCollectClosure from "../../clickAndCollect/addClickAndCollectClosure";

export default {
    props: {
        closure_id: {
            default: null,
        },
    },
    methods: {
        close(e) {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            e.stopPropagation();
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        addClickAndCollectClosure,
    },
};
</script>
